import { authorizedInstance } from "../config/axios"

export const getErrorLogs = async ({ page, limit, filters }) => {
  const query = new URLSearchParams({
    page,
    limit,
    ...filters,
  })

  const response = await authorizedInstance.get(`/error-logs?${query}`)

  return response.data
}

export const getErrorLogWithMessageId = async (
  messageId,
  bodyPart,
  viewType
) => {
  const response = await authorizedInstance.get(
    `/error-logs/log?messageId=${messageId}&bodyPart=${bodyPart}&viewType=${viewType}`
  )

  return response.data
}

export const getErrorRelatedReports = async ({ page, limit, filters }) => {
  const query = new URLSearchParams({
    page,
    limit,
    ...filters,
  })

  const response = await authorizedInstance.get(`/error-logs/reports?${query}`)

  return response.data
}
